export default __webpack_public_path__ + "static/media/service05.cb09143f.png";